module.exports = __webpack_public_path__ + "img/bg2.8b74088f.jpg";